import * as React from "react";
import * as styles from "./Input.less";

/**
 * If a row with labeled inputs ends with any other control, for ex. a switcher, the switcher should be aligned vertically with the inputs.
 */
export const InputWithLabelAlignment: React.FC = ({ children }) => (
    <div className={styles.input_with_label_aligner}>{children}</div>
);
